var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('data-table',{attrs:{"headers":_vm.headers,"data":_vm.userArticles,"loading":_vm.loading,"pageNumber":_vm.articlesPageNumber,"paginate":_vm.paginate,"options":_vm.options}},[_c(_vm.headerChildComponent,{tag:"component",attrs:{"refreshData":_vm.handleRefreshData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }